<template>
  <div class="my-4">
    <div class="text-h6 font-weight-bold mb-3">
      Mes liens de groupe
      <v-chip class="ml-2" color="primary-dark" variant="flat" size="small">{{ liens.length }}</v-chip>
    </div>

    <div v-for="lien in liens" :key="lien.token" class="mb-4">
      <div class="d-flex align-center py-2 px-3 rounded-t flex-wrap" style="background-color: #e9edf4;">
        <v-icon size="40px" color="darkblue" icon="mdi-account-group" class="mr-3"></v-icon>
        <div>
          <div class="text-h6 font-weight-bold">{{ lien.nom }} ({{ lien.token }})</div>
        </div>
      </div>
      <div class="rounded-b bordered border-light_bluegrey pa-2">
        <v-row class="my-1">
          <v-col class="py-1" cols="12" sm="6">
            <DenseActionCard title="Suivi du groupe" description="Consulter les inscriptions de ce groupe"
              icon="mdi-chart-timeline-variant" :toPage="getSuiviRoute(lien.token)"></DenseActionCard>
          </v-col>
          <v-col class="py-1" cols="12" sm="6">
            <DenseActionCard title="Inscrire un participant"
              description="Inscrire un nouveau participant via ce lien de groupe" icon="mdi-account-plus"
              :toPage="getInscriptionRoute(lien.token)"></DenseActionCard>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import DenseActionCard from "@/components/App/UI/DenseActionCard.vue";

export default {
  components: { DenseActionCard },
  props: {
    liens: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {
    getSuiviRoute(token) {
      return {
        name: "SuiviLienGroupe",
        params: { base_module: this.mainStore.module.base, token },
      };
    },
    getInscriptionRoute(token) {
      return {
        name: "Home",
        params: { base_module: this.mainStore.module.base },
        query: { groupe: token },
      };
    },
  },
};
</script>

<style lang="scss" scoped></style>
